export class PropertyPartyDTO{
    public id?:number;
    public propertyId!:number;
    public partyType!:string;
    public party!:string; //json
}